import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { Source } from 'app/models/source.enum';
import { File } from 'app/models/file';
import { CompetitionService } from 'app/services/competition.service';
import { Document } from 'app/models/document';

@Injectable()
export class OnboardingService {

  apiUrl: string = environment.api.url + environment.api.content.url;

  constructor(private http: HttpClient, private competitionService: CompetitionService) {}

  getAll(): Observable<Array<File>> {
    let params = new HttpParams();
    params = params.append('competition', this.competitionService.getCompetitionId());
    params = params.append('op', environment.api.content.type.assets.op);
    params = params.append('source', Source.Onboarding);

    return this.http
      .get<any>(this.apiUrl, { params })
      .map(res => res ? res.Items.map(el => <File>el) : [])
      .catch(err => Observable.throw(err || 'ServerErr'));
  }

  create(doc: Document): Observable<File> {
    const fileItem = new File(null, this.competitionService.getCompetitionId(),
                              doc.name, doc.displayName, doc.contentType,
                              doc.createdTime, new Date().getTime(), Source.Onboarding,
                              doc.id, doc.contentId);
    return this.http
      .post<File>(this.apiUrl, fileItem)
      .map(res => <File>res)
      .catch(err => Observable.throw(err || 'ServerErr'));
  }

  saveCoverPage(coverPage: File): Observable<File> {
    coverPage.updateDate = new Date().getTime();
    if (coverPage.id) {
      return this.http
        .put<File>(this.apiUrl, coverPage)
        .map(res => <File>res)
        .catch(err => Observable.throw(err || 'ServerErr'));
    } else {
      coverPage.parentId = this.competitionService.getCompetitionId();
      coverPage.coverPage = true;
      coverPage.createdTime = new Date().getTime();
      coverPage.source = Source.Onboarding;
      return this.http
        .post<File>(this.apiUrl, coverPage)
        .map(res => <File>res)
        .catch(err => Observable.throw(err || 'ServerErr'));

    }
  }

  remove(id: string): Observable<string> {
    let params = new HttpParams();
    params = params.append('op', environment.api.content.type.assets.op);
    params = params.append('element', id);

    return this.http
      .delete<Document>(this.apiUrl, { params })
      .map(res => <Document>res)
      .catch(err => Observable.throw(err || 'ServerErr'));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/onboarding.service.ts